import axios from 'axios';
// production url
let url = 'https://shillguard-001-site9.mtempurl.com/api';
//let url = 'https://shillguard-001-site2.etempurl.com';
// development url
//https://shillguard-001-site2.etempurl.com
// if(window && (window.location.href.indexOf('shillguard.revolutionlab.bg') !== -1)) {
//     url = 'https://revolutionlab-001-site7.itempurl.com';
// }
export const baseUrl = url;
export const getAllSignals = () => {
    const url = baseUrl + '/signals/GetAllSignals';
    return axios.get(url).then(res => res.data);
}

export const getSingleItem = (NameOfCallGroup) => {
    const url = baseUrl + `/signals/GetAllSignalsByCallGroupName/${NameOfCallGroup}`
    return axios.get(url).then(res => res.data);
}

export const getTopSignalsByCallGroup = (NameOfCallGroup) => {
    const url = baseUrl + `/signals/GetAllSignalsByCallGroupName/${NameOfCallGroup}/isTop3=true`
    return axios.get(url).then((res) => {
        return res.data;
    })
    .catch((err) => {
        // The value 'isTop3=true' is not valid.
        console.log(err)
    });
}

export const getTopFiveCallers = () => {
    const url = baseUrl + `/signals/GetTop5Callers`;
    return axios.get(url).then((res) => {
        return res.data;
    })
    .catch((err) => {
        console.log(err)
    });
}

export const getTopFiveSignals = () => {
    const url = baseUrl + `/signals/GetTop5Signals`;
    return axios.get(url).then((res) => {
        return res.data;
    })
    .catch((err) => {
        console.log(err)
    });
}

export const getTopFiveSignalsMonthly = () => {
    const url = baseUrl + `/signals/GetTop5SignalsMontly`;
    return axios.get(url).then((res) => {
        return res.data;
    })
    .catch((err) => {
        console.log(err)
    });
}

export const getAllNews = () => {
    const url = baseUrl + `/news/GetAllNewsFromDb`;
    return axios.get(url).then((res) => {
        return res.data;
    })
    .catch((err) => {
        console.log(err)
    });
}

export const getTopTrendingTokens = () => {
    const url = baseUrl + `/signals/GetTopTrendingTokens`;
    return axios.get(url).then((res) => {
        return res.data;
    })
    .catch((err) => {
        console.log(err)
    });
}

export const getTop5Visited = () => {
    const url = baseUrl + `/signals/GetTop5Visited`;
    return axios.get(url).then((res) => {
        return res.data;
    })
    .catch((err) => {
        console.log(err)
    });
}

export const loadNewsItems = (skip, pageSize) => {
    const url = baseUrl + `/news/GetAllNewsFromDb/${skip}/${pageSize}`
    return axios.get(url).then(res => res.data);
}

export const getChartData = (groupName) => {
    const url = baseUrl + `/signals/GetStats/${groupName}`
    return axios.get(url, { validateStatus: false }).then(res => res);
}

export const getTokenStatSearch = (string) => {
    const url = baseUrl + `/signals/GetTokenStat/${string}`
    return axios.get(url, { validateStatus: false }).then(res => res.data);
}

export const getAllSignalsSearch = () => {
    const url = baseUrl + `/signals/AutocompleteSignals`
    return axios.get(url, { validateStatus: false }).then(res => res.data);
}

export const getAllCallers = () => {
    const url = baseUrl + `/signals/GetAllCallers`
    return axios.get(url, { validateStatus: false }).then(res => res.data);
}

export const getTelegramTasks = () => {
    const url = baseUrl + `/TelegramApp/tasks`
    return axios.get(url, { validateStatus: false }).then(res => res.data);
}


export const requestTelegramNonce = async (initData, botToken) => {
  const r = await fetch('/api/telegram/nonce', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ initData, botToken })
  });
  if (!r.ok) throw new Error('nonce request failed');
  return r.json(); // { nonce }
};

export const linkTelegramWallet = async (telegramId, wallet, signature) => {
  const r = await fetch('/api/telegram/link', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ telegramId, wallet, signature })
  });
  if (!r.ok) throw new Error('link failed');
  return r.json();
};

export const getTelegramUserWallet = async (telegramId) => {
  const r = await fetch(`/api/telegram/user-wallet/${encodeURIComponent(telegramId)}`);
  if (!r.ok) return null;
  return r.json(); // { wallet }
};

export const getTelegramUserTasksByWalletId = async (walletId) => {
  const url = baseUrl + `/TelegramApp/tasks/${walletId}`
  return axios.get(url, { validateStatus: false }).then(res => res.data);
};

export const completeTask = async (data) => {
  const url = baseUrl + `/TelegramApp/tasks/complete`
  return axios.put(url, data, { validateStatus: false }).then(res => res.data);
};